import React, { useEffect, useRef } from 'react';
import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import CanShow from '../../shared/components/CanShow';
import '../AppSidebar.styles.css';
import getNavIcon from './menu.icon';
import { getColors } from '../../theme';

const colors = getColors();

function SidebarCollapsed({ menu, open, setOpen, setExpand, expand, drawopen, setOpenSubMenuId }) {
  const { colorShades, text, primary } = colors;
  const { collapsedModuleName, moduleName, icon, path } = menu;
  const multiLevelMenuRef = useRef();

  const isChildActive = menu.menus.some((m) => {
    if (m.menuId === sessionStorage.getItem('subMenu1')) {
      return true;
    }
    return m.childMenu?.some((c) => {
      const cMenuId = sessionStorage.getItem('subMenu1');
      return c.menuId === cMenuId;
    });
  });

  const styleObj = {
    fontSize: 9,
    marginTop: '-6px',
    marginLeft: drawopen && '3px',
    color: text.sideBar,
  };

  const isExpanded = expand === path;

  const toggleCollapse = () => {
    setExpand(isExpanded ? null : path);
    setOpenSubMenuId(null);
  };

  const handleClickOutside = (e) => {
    if (multiLevelMenuRef.current && !multiLevelMenuRef.current.contains(e.target)) {
      if (!drawopen) {
        setOpenSubMenuId(null);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  useEffect(() => {
    if (isChildActive) setExpand(path);
  }, [isChildActive]);

  const handleHover = () => {
    setOpen(true);
    if (drawopen) {
      setOpenSubMenuId(sessionStorage.getItem('subMenu1') || null);
    }
  };

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        className={`parent-menu ${isChildActive ? open && 'active' : ''} ${
          isChildActive ? !open && 'hactive' : ''
        }`}
        onClick={toggleCollapse}
        selected={isChildActive}
        onMouseEnter={handleHover}
        sx={{
          justifyContent: open ? 'initial' : 'center',
          px: !open ? 2.5 : 1,
          py: 0,
          paddingBottom: !open ? '15px' : '0px',
          textAlign: !open && 'center',
          height: !open && '60px',
          borderRadius: '0px 24px 24px 0px',
          marginRight: '12px',
          ':hover': {
            backgroundColor: primary.veryLightAlt,
          },
          '&.Mui-selected': {
            backgroundColor: primary.veryLightAlt,
          },
          '&.Mui-selected:hover': {
            backgroundColor: primary.veryLightAlt,
          },
        }}
      >
        <Box
          className="highlighter"
          sx={{
            width: 6,
            position: 'absolute',
            left: 0,
            height: 45,
            backgroundColor: primary.main,
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
          }}
        />
        <ListItemIcon
          sx={{
            minWidth: 0,
            justifyContent: 'center',
            padding: !open ? '10px 20px' : '10px 0',
          }}
        >
          <Box>
            <Box sx={{ color: !open && text.accent, marginLeft: drawopen && '3px' }}>
              {getNavIcon(icon)}
            </Box>
            <p style={styleObj}>{!open && (collapsedModuleName || moduleName)}</p>
          </Box>
        </ListItemIcon>
        <Tooltip title={collapsedModuleName || moduleName} placement="right">
          <ListItemText
            primaryTypographyProps={{ color: colorShades.greyShade, noWrap: true, ml: 1 }}
            primary={open && (collapsedModuleName || moduleName)}
          />
        </Tooltip>
        <CanShow show={open}>
          {isExpanded ? (
            <ExpandLess sx={{ color: text.secondary }} />
          ) : (
            <ExpandMore sx={{ color: text.secondary }} />
          )}
        </CanShow>
      </ListItemButton>
    </ListItem>
  );
}
export default SidebarCollapsed;
